const UniversityTable2026 = () => {
  return (
    <div className="relative">
      {/* 背景の桜SVG */}
      <div className="absolute inset-0 flex justify-center items-center opacity-10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
          viewBox="0 0 24 24"
          fill="pink"
        >
          <path d="M12 2c1.1 0 2 .9 2 2 0 .45-.15.86-.4 1.2.58-.12 1.22-.2 1.88-.2 2.21 0 4 1.79 4 4 0 .99-.37 1.9-.98 2.6.2-.03.4-.06.6-.06 1.1 0 2 .9 2 2 0 1.24-.95 2.25-2.17 2.38 0 .07.01.14.01.22 0 2.21-1.79 4-4 4-1.06 0-2.03-.42-2.74-1.1-.71.68-1.68 1.1-2.74 1.1-2.21 0-4-1.79-4-4 0-.08.01-.15.01-.22C4.95 16.25 4 15.24 4 14c0-1.1.9-2 2-2 .2 0 .4.03.6.06-.61-.7-.98-1.61-.98-2.6 0-2.21 1.79-4 4-4 .66 0 1.3.08 1.88.2A1.99 1.99 0 0112 2z" />
        </svg>
      </div>

      {/* 国公立大学テーブル */}
      <div className="mb-10">
        <h2 className="text-2xl font-bold text-red-600 text-center mb-4">国公立大学</h2>
        <table className="table-auto border-collapse border border-red-300 w-full text-left">
          <thead>
            <tr className="bg-red-500 text-white">
              <th className="border border-red-300 px-4 py-2">大学名</th>
              <th className="border border-red-300 px-4 py-2">人数</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["北海道大(文)", "1名"],
              ["東京学芸大(教育)", "1名"],
              ["東京科学大(理)", "1名"],
              ["静岡大(情報)", "1名"],
              ["京都大(理)", "1名"],
              ["京都工芸繊維大(工芸科学)", "1名"],
              ["岡山大(教育)", "1名"],
              ["岡山大(医-医)", "1名"],
              ["山口大(理)", "2名"],
              ["香川大(経済)", "3名"],
              ["愛媛大(法文)", "1名"],
              ["愛媛大(医-医)", "1名"],
              ["高知大(人文社会)", "6名"],
              ["高知大(教育)", "3名"],
              ["高知大(理工)", "3名"],
              ["高知大(医-医)", "2名"],
              ["高知大(医-看護)", "2名"],
              ["高知大(農林海洋)", "1名"],
              ["岐阜薬大(薬)", "1名"],
              ["高知工科大(経済・マネジメント)", "2名"],
              ["高知工科大(システム工)", "1名"],
              ["高知県立大(看護)", "1名"],
              ["福岡県立大(看護)", "1名"],
              ["気象大学校", "1名"],
              ["国立看護大学校", "1名"],
              ["", "現役生も含む"],
            ].map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-red-100" : "bg-white"}>
                <td className="border border-red-300 px-4 py-2">{row[0]}</td>
                <td className="border border-red-300 px-4 py-2">{row[1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 私立大学テーブル */}
      <div>
        <h2 className="text-2xl font-bold text-red-600 text-center mb-4">私立大学</h2>
        <table className="table-auto border-collapse border border-red-300 w-full text-left">
          <thead>
            <tr className="bg-red-500 text-white">
              <th className="border border-red-300 px-4 py-2">大学名</th>
              <th className="border border-red-300 px-4 py-2">人数</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["流通経済大", "1名"],
              ["獨協大", "3名"],
              ["人間総合科学大", "1名"],
              ["国士舘大", "1名"],
              ["順天堂大", "1名"],
              ["帝京大", "1名"],
              ["東京理科大", "1名"],
              ["東洋大", "2名"],
              ["日本大", "2名"],
              ["日本女子大", "1名"],
              ["法政大", "1名"],
              ["早稲田大", "1名"],
              ["京都外国語大", "1名"],
              ["京都産業大", "9名"],
              ["京都女子大", "3名"],
              ["京都精華大", "1名"],
              ["京都橘大", "2名"],
              ["同志社大", "3名"],
              ["同志社女子大", "1名"],
              ["佛教大", "1名"],
              ["立命館大", "3名"],
              ["龍谷大", "16名"],
              ["追手門学院大", "1名"],
              ["大阪医科薬科大", "1名"],
              ["大阪産業大", "1名"],
              ["関西大", "1名"],
              ["関西外国語大", "5名"],
              ["近畿大", "8名"],
              ["摂南大", "2名"],
              ["桃山学院大", "1名"],
              ["大和大", "5名"],
              ["関西学院大", "8名"],
              ["神戸学院大", "1名"],
              ["神戸女学院大", "2名"],
              ["神戸薬科大", "1名"],
              ["岡山理科大", "2名"],
              ["川崎医療福祉大", "1名"],
              ["美作大", "2名"],
              ["環太平洋大", "1名"],
              ["広島修道大", "3名"],
              ["四国大", "1名"],
              ["徳島文理大", "6名"],
              ["松山大", "14名"],
              ["", "現役生も含む"],
            ].map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-red-100" : "bg-white"}>
                <td className="border border-red-300 px-4 py-2">{row[0]}</td>
                <td className="border border-red-300 px-4 py-2">{row[1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UniversityTable2026;